import React from 'react';
import { useState, useEffect } from 'react';
import { api } from '../utils';
import { Moment } from 'moment';
import AnalyticsLoader from '../assets/icons/loader.svg';
import ListIcon from '../assets/icons/list.svg';
import RankingList from './RankingList';
import BackBtnIcon from '../assets/icons/arrow_back.svg';
// import BotPannel from '../CommonComponents/BotPannel';

type Props = {
	selectedBotid: string;
	selectedSource: { name: string; id: number; deviceInfo?: string };
	selectedAgent: { name: string; id: number };
	selectedQueue: { name: string; id: number };
	startDate: Moment;
	endDate: Moment;
	utcstartDate: any;
	utcendDate: any;
	redirectionToLoginPage: Function;
	ongoingCardList: {
		title: string;
		count: number;
		defnitions: string;
	}[];
	setviewAgentList: Function;
	getcurrentAgentsList: Function;
};
const RealTime = ({
	selectedBotid,
	selectedSource,
	selectedAgent,
	selectedQueue,
	startDate,
	endDate,
	utcstartDate,
	utcendDate,
	redirectionToLoginPage,
	ongoingCardList,
	setviewAgentList,
	getcurrentAgentsList,
}: Props) => {
	const [newOngoingCardList, setNewOngoingCardList] = useState(ongoingCardList);

	const [isRealTimedataLoading, setIsRealTimedataLoading] = useState();
	let interval: any = 0;
	const getRealTimeDetails = () => {
		let analyticsBotid = '';
		if (selectedBotid !== '') {
			analyticsBotid = selectedBotid;
		}
		if (analyticsBotid === '') {
			return;
		}
		let datachannel = '';
		if (selectedSource.name.indexOf('Web') > -1) {
			datachannel = 'webs';
		} else if (selectedSource.name === 'WhatsApp') {
			datachannel = 'whatsapp';
		} else {
			datachannel = selectedSource.name;
		}
		let filterType = '';
		if (selectedAgent.id !== -1) {
			filterType = 'agent';
		}
		if (selectedQueue.id !== -1) {
			filterType = 'queue';
		}
		if (selectedQueue.id !== -1 && selectedAgent.id !== -1) {
			filterType = 'both';
		}
		api(
			`getRealtimeAnalyticsForWebAware?start=${utcstartDate}&end=${utcendDate}&agentId=${
				selectedAgent.id
			}&queueId=${selectedQueue.id}&channel=${datachannel}&deviceInfo=${
				selectedSource.deviceInfo
			}&botId=${encodeURIComponent(
				analyticsBotid
			)}&filterType=${filterType}&timezoneOffset=${new Date().getTimezoneOffset()}&agentSessionID=${sessionStorage.getItem(
				'agentActiveSession'
			)}`
		).then((response: any) => {
			// if (response.redirectToLogin === true) {
			// 	redirectionToLoginPage();
			// }
			if (response.error === 'Authentication Failed') {
				redirectionToLoginPage();
			}
			var newState = newOngoingCardList.map((card: any) => {
				switch (card.title) {
					case 'Total handed off chats':
						return {
							...card,
							count: response.TotalHandedOffChats,
						};
					case 'Agents online':
						return {
							...card,
							count: response.AgentsOnline,
						};
					case 'Chats in queue':
						return {
							...card,
							count: response.ChatsInQueue,
						};
					default:
						return card;
				}
			});

			setNewOngoingCardList(newState);
		});
	};

	useEffect(() => {
		// eslint-disable-next-line react-hooks/exhaustive-deps
		interval = setInterval(() => {
			getRealTimeDetails();
		}, 10000);

		return () => {
			clearInterval(interval);
		};
	}, [getRealTimeDetails]);

	return (
		<div>
			<div
				style={{
					fontSize: '20px',
					fontWeight: 600,
					borderBottom: '1px solid #0000001a',
					paddingBottom: '20px',
					letterSpacing: '-0.3px',
					marginLeft: '36.5px',
					marginTop: '44px',
				}}>
				{' '}
				Realtime{' '}
			</div>
			<div className='stats-wrapper'>
				{!isRealTimedataLoading &&
					newOngoingCardList.map((card: any, index: number) => {
						return (
							<div key={index} className='stat' title={card.defnitions}>
								<div className='title'>{card.title}</div>
								<div className='count'>{card.count}</div>
								{card.title === 'Agents online' && card.count > 0 ? (
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<div className='view'>
											<div
												className='clickable'
												onClick={() => {
													// this.viewchats(card.title);
													getcurrentAgentsList();
													setviewAgentList(true);
													getRealTimeDetails();
												}}
												style={{
													display: 'flex',
													justifyContent: 'center',
												}}>
												<img src={ListIcon} alt='chat' />
												View list
											</div>
										</div>
									</div>
								) : null}
							</div>
						);
					})}
			</div>
			{isRealTimedataLoading ? (
				<div
					className='agent-ranking-loader'
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						cursor: 'pointer',
						marginTop: '50px',
					}}>
					<img src={AnalyticsLoader} alt='loader' />
				</div>
			) : null}

			{/* {!isRealTimedataLoading && viewAgentList ? (
       
      ) : null} */}
		</div>
	);
};

export default RealTime;
